import type { ReactNode } from 'react';
import { StatusPage } from './status-page';

/** Página 403: autenticado, mas sem permissão no JAF. */
export function ForbiddenPage(): ReactNode {
  return (
    <StatusPage
      title="Acesso negado"
      description="Sua conta não tem permissão para acessar este recurso. Procure o administrador da sua organização."
    />
  );
}
